export default "__VITE_ASSET__C93G9lu6__"